import StyledSVGIcon from './StyledSVGIcon'

const svgContent = `<svg width="70" height="58" viewBox="0 0 70 58" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
  <title>ByteBeam</title>
<path d="M69.952 14.532L40.0684 0L54.1477 17.7426L69.952 14.532Z" fill="currentColor"/>
<path d="M69.952 42.7717L40.0684 57.3037L54.1477 39.5611L69.952 42.7717Z" fill="currentColor"/>
<path d="M54.1474 17.743L63.0391 28.6969L54.1474 39.5368L0 28.642L54.1474 17.743Z" fill="currentColor"/>
</svg>`

type LogoMarkProps = {
	size?: string
	color?: string
	[x: string]: unknown
}

function LogoMark({ size = '16px', color, ...rest }: LogoMarkProps) {
	const themeColor =
		typeof document !== 'undefined'
			? getComputedStyle(document.documentElement).getPropertyValue('--foreground').trim()
			: ''

	return (
		<span className='inline-flex items-center justify-center shrink-0' style={{ width: size, height: size }}>
			<StyledSVGIcon height={size} {...rest} svgContent={svgContent} altColor={color || themeColor} />
		</span>
	)
}

export default LogoMark
